import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { DeliveryDestinations } from '../../../../interfaces/deliveryDestionations.model';
import { CustomersAddressDetailsDialogComponent } from '../customers-address-details-dialog-component/customers-address-details-dialog-component';

@Component({
  selector: 'cus-customers-delivery-destinations-dialog-component',
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
  ],
  templateUrl: './customers-delivery-destinations-dialog-component.html',
  styleUrl: './customers-delivery-destinations-dialog-component.scss',
})
export class CustomersDeliveryDestinationsDialogComponent {
  readonly destinationFields = [
    { label: 'Riferimento', key: 'riferimento' },
    { label: 'Citta', key: 'citta' },
    { label: 'CAP', key: 'cap' },
    { label: 'Indirizzo', key: 'indirizzo' },
  ] as const;
  selectedIndex = 0;
  private addressDetailsDialogRef?: MatDialogRef<CustomersAddressDetailsDialogComponent>;

  constructor(
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<CustomersDeliveryDestinationsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) readonly destinations: DeliveryDestinations[],
  ) {}

  onClose() {
    this.dialogRef.close();
  }

  onReset() {
    this.dialogRef.close({ action: 'reset' });
  }

  onApply() {
    this.dialogRef.close({ action: 'apply' });
  }

  onSelectDestination(index: number) {
    this.selectedIndex = index;
  }

  openAddressDetailsDialog(event: MouseEvent, destination: DeliveryDestinations) {
    event.stopPropagation();

    if (this.addressDetailsDialogRef) {
      return;
    }

    this.addressDetailsDialogRef = this.dialog.open(CustomersAddressDetailsDialogComponent, {
      data: destination,
    });
    this.addressDetailsDialogRef.afterClosed().subscribe(result => {
      this.addressDetailsDialogRef = undefined;

      if (result?.action === 'edit') {
        this.dialogRef.close(result);
      }
    });
  }
}
